import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import Condicionais1 from '../imagens/LancCondicionais/Condicionais1.png';
import Condicionais2 from '../imagens/LancCondicionais/Condicionais2.png';
import Condicionais3 from '../imagens/LancCondicionais/Condicionais3.png';
import Condicionais4 from '../imagens/LancCondicionais/Condicionais4.png';
import Condicionais5 from '../imagens/LancCondicionais/Condicionais5.png';
import Condicionais6 from '../imagens/LancCondicionais/Condicionais6.png';
import Condicionais7 from '../imagens/LancCondicionais/Condicionais7.png';
import "./Modal.css";

export default class Condicionais extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como utilizar o gerenciamento de Condicionais"
        className="modal"
        visible={isOpen}
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <Col xs={24}>
            <p>Para acessar o gerenciamento de Condicionais siga o seguinte atalho:  </p>

            <div className="image-wrapper">
              <img className="img_smaller" src={Condicionais1} alt="Condicional 1"/>
            </div>     

            <div className="gray_bar"></div>

            <div className="image-wrapper">
              <img src={Condicionais2} alt="Condicional 2"/>
            </div>     

                        
          <h3>Na tela de Condicionais nós temos:</h3>
            <ol>
                <li>Botão para cadastrar uma nova Condicional.</li> 
                <li>Filtros para buscar Condicionais.</li>
                <li>Impressão de todas as condicionais.</li>
                <li>Tabela mostrando todas as condicionais cadastradas.</li>
                <li>Botões auxiliares de alteração/exclusão/impressão da Condicional.</li>
                <li>Paginação da tabela de condicionais.</li>                
            </ol>   

            <div className="gray_bar"></div>

            <h3>Como cadastrar uma nova Condicional</h3>

            <p>
              Para cadastrar uma nova Condicional basta clicar no botão "Adicionar" no canto superior esquerdo da tela e inserir os dados necessários da página de cadastro
              que é aberta.
            </p>     
            <div className="image-wrapper">
              <img src={Condicionais3} alt="Condicional 3"/>
            </div>  
            <p>
              O cadastro de condicionais possui duas abas: A aba de dados principais e a aba de lista de produtos da condicional. A aba de dados principais serve para definir 
              o vendedor responsável, o cliente ao qual a condicional se refere, e informações em geral. 
            </p>  
            <div  className="image-wrapper">
              <img src={Condicionais4} alt="Condicional 4"/>
            </div>  
            <p>
              Na segunda aba de lista de produtos o gestor pode adicionar os itens que foram liberados ao cliente em condicional. Para adicionar um novo item a lista basta clicar
              no botão "+ Novo produto". Caso deseje alterar/excluir um item da lista, basta clicar nos botões com o lápis (alterar) ou o botão com a lixeria (excluir).
            </p> 
            <div  className="image-wrapper">
              <img src={Condicionais5} alt="Condicional 5"/>
            </div> 
            <p>Após terminar de preeencher as informações basta clicar no botão "Salvar condicional" para salvar e terminar o cadastro da condicional.</p>   

            <div className="gray_bar"></div>

            <h3>Como alterar/Excluir uma venda</h3>
            <p>Para  Alterar/Excluir uma Condicional utilize as opções extras dentro da tabela de registros.</p>    
            <div  className="image-wrapper">
              <img src={Condicionais6} alt="Condicional 6"/>
            </div>  

            <div className="gray_bar"></div>

            <h3>Como filtrar as Condicionais</h3>   
            <p>Para facilitar a busca de Condicionais você pode utilizar os filtros avançados clicando no botão "Filtrar."</p>              
            <div  className="image-wrapper">
              <img src={Condicionais7} alt="Condicional 6"/>
            </div> 
          </Col>
        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancCondicionais.js